module.exports = __webpack_public_path__ + "img/cast.c866c851.svg";